module.exports = __webpack_public_path__ + "img/car_shina2_37.0711b824.jpg";